<div id="render" #rendererContainer (click)="!isIpad && createAlignmentPoints($event)"
    (touchstart)="createAlignmentPoints($event)" (mousemove)="showObjectsBeforeAdd($event)">
</div>

<div class="design-engine-logo"><img style="max-height: 70px; width: auto;" src="{{customLogo}}"></div>

<div id="viewHelper" (pointerup)="handleClick($event)"
    style="position: absolute; right: 0; bottom: 0; height: 128px; width: 128px;"></div>

<div
    style="position: fixed; margin-top: -95vh; margin-left: 2vw; width: 50px; height: 50px; z-index: 2; float: right; ">

    <button *ngIf="canGoBack" (click)="backButton()" mat-raised-button color="primary"><i
            class="pi pi-arrow-left text-blue"></i></button>
</div>


<div class="top-buttons">

    <div *ngIf="fileLoaded" class="col-12 row">
        <div class="col-6">
            <button (click)="reloadFile()" mat-raised-button color="primary"
                pTooltip="{{ 'RELOAD_FILE' | translate }}"><i class="pi pi-refresh text-blue"></i></button>
        </div>
        <div class="col-6">
            <button (click)="saveFile()" mat-raised-button color="primary" pTooltip="{{ 'SAVE_FILE' | translate }}"><i
                    class="pi pi-save text-white"></i></button>
        </div>
    </div>
</div>

<div class="scan-workflow-stepper" *ngIf="fileLoaded">
    <p-stepper #stepper orientation="vertical" [linear]="false" [activeStep]="currentStepIndex">

        <!-- Step 1: Set Landmarks -->
        <p-stepperPanel header="{{ 'SET_LANDMARKS' | translate }}">
            <ng-template pTemplate="header" let-index="index" let-active="active" let-highlighted="highlighted">
                <span class="step-icon" [class.completed]="step1Completed" [class.active]="active"
                    [style.background-color]="step1Completed ? '#28a745' : (active ? '#007bff' : '#e9ecef')"
                    [style.color]="step1Completed || active ? 'white' : '#6c757d'">
                    <i class="pi pi-bullseye" *ngIf="!step1Completed"></i>
                    <i class="pi pi-check" *ngIf="step1Completed"></i>
                </span>
                <span class="step-title" [class.completed]="step1Completed"
                    [style.color]="step1Completed ? '#28a745' : '#495057'"
                    [style.font-weight]="step1Completed ? '600' : '500'">{{ 'SET_LANDMARKS' | translate }}</span>
            </ng-template>

            <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback">
                <div class="step-content">
                    <button (click)="startAlignment(); nextCallback.emit()" pButton class="step-button bg-primary">
                        <i class="pi pi-bullseye"></i>
                        {{ 'SET_LANDMARKS' | translate }}
                    </button>
                </div>
            </ng-template>
        </p-stepperPanel>

        <!-- Step 2: Modify Scan -->
        <p-stepperPanel header="{{ 'MODIFY_SCAN' | translate }}">
            <ng-template pTemplate="header" let-index="index" let-active="active" let-highlighted="highlighted">
                <span class="step-icon" [class.completed]="step2Completed" [class.active]="active"
                    [style.background-color]="step2Completed ? '#28a745' : (active ? '#007bff' : '#e9ecef')"
                    [style.color]="step2Completed || active ? 'white' : '#6c757d'">
                    <i class="pi pi-cog" *ngIf="!step2Completed"></i>
                    <i class="pi pi-check" *ngIf="step2Completed"></i>
                </span>
                <span class="step-title" [class.completed]="step2Completed"
                    [style.color]="step2Completed ? '#28a745' : '#495057'"
                    [style.font-weight]="step2Completed ? '600' : '500'">{{ 'MODIFY_SCAN' | translate }}</span>
            </ng-template>

            <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback">
                <div class="step-content">
                    <div class="modify-buttons">
                        <button (click)="initCutPlanes()" pButton class="bg-primary step-button">
                            <i class="pi pi-star-half"></i>
                            {{ 'CROP' | translate }}
                        </button>
                        <button (click)="invertScan()" pButton class="bg-primary step-button">
                            <i class="pi pi-sort-alt"></i>
                            {{ 'INVERT' | translate }}
                        </button>
                        <button (click)="rotate180()" pButton class="bg-primary step-button">
                            <i class="pi pi-sort"></i>
                            {{ 'ROTATE_180' | translate }}
                        </button>
                    </div>
                    <div class="step-navigation">
                        <button (click)="prevCallback.emit()" pButton class="p-button-secondary prev-button">
                            <i class="pi pi-arrow-left"></i>
                        </button>
                        <button (click)="nextCallback.emit()" pButton class="p-button-secondary next-button">
                            <i class="pi pi-arrow-right"></i>
                        </button>
                    </div>
                </div>
            </ng-template>
        </p-stepperPanel>

        <!-- Step 3: Save Scan -->
        <p-stepperPanel header="{{ 'SAVE_SCAN' | translate }}">
            <ng-template pTemplate="header" let-index="index" let-active="active" let-highlighted="highlighted">
                <span class="step-icon" [class.completed]="step3Completed" [class.active]="active"
                    [style.background-color]="step3Completed ? '#28a745' : (active ? '#007bff' : '#e9ecef')"
                    [style.color]="step3Completed || active ? 'white' : '#6c757d'">
                    <i class="pi pi-save" *ngIf="!step3Completed"></i>
                    <i class="pi pi-check" *ngIf="step3Completed"></i>
                </span>
                <span class="step-title" [class.completed]="step3Completed"
                    [style.color]="step3Completed ? '#28a745' : '#495057'"
                    [style.font-weight]="step3Completed ? '600' : '500'">{{ 'SAVE_SCAN' | translate }}</span>
            </ng-template>

            <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback">
                <div class="step-content">
                    <button (click)="saveFile()" pButton class="step-button save-button">
                        <i class="pi pi-save"></i>
                        {{ 'SAVE_SCAN' | translate }}
                    </button>
                    <div class="step-navigation">
                        <button (click)="prevCallback.emit()" pButton class="p-button-secondary prev-button">
                            <i class="pi pi-arrow-left"></i>
                        </button>
                    </div>
                </div>
            </ng-template>
        </p-stepperPanel>

    </p-stepper>

    <!-- Design Engine Navigation (Optional Next Step) -->
    <div class="design-navigation" *ngIf="fileLoaded">
        <div class="design-card">
            <div class="workflow-steps">
                <div class="workflow-step current-step">
                    <div class="step-indicator">
                        <span class="step-number">1</span>
                        <span class="step-status">{{ 'CURRENT' | translate }}</span>
                    </div>
                    <div class="step-content">
                        <h5>{{ 'CLEANING_SCAN' | translate }}</h5>
                        <p>{{ 'CLEANING_SCAN_DESCRIPTION' | translate }}</p>
                    </div>
                </div>

                <div class="step-arrow">
                    <i class="pi pi-arrow-right"></i>
                </div>

                <div class="workflow-step next-step">
                    <div class="step-indicator">
                        <span class="step-number">2</span>
                        <span class="step-status">{{ 'OPTIONAL' | translate }}</span>
                    </div>
                    <div class="step-content">
                        <button (click)="showProductSelector()" pButton class="design-start-button"
                            [disabled]="!hasAtLeastOnePaidFile()">
                            <i class="pi pi-cog"></i>
                            {{ 'START_DESIGN' | translate }}
                        </button>
                        <p *ngIf="!hasAtLeastOnePaidFile()" class="disabled-message">
                            {{ 'MIN_1_SCAN_PAID_TO_DESIGN' | translate }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="bottom-buttons-container-top">
    <button *ngIf="fileLoaded?.paid && textureLoaded" (click)="exportPLY()" mat-raised-button color="primary"
        pTooltip="Export PLY">{{ 'EXPORT_PLY' | translate }}</button>
</div>

<div class="lateral-buttons-container-bottom">

    <button (click)="toggleTranslateMesh()" mat-raised-button color="primary"
        pTooltip="{{ 'TRANSLATE' | translate }}"><i class="pi pi-arrows-v text-blue"></i></button>

    <button (click)="toggleRotateMesh()" mat-raised-button color="primary" pTooltip="{{ 'ROTATE' | translate }}"><i
            class="pi pi-refresh text-blue"></i></button>
</div>

<div *ngIf="aligning"
    style="position: fixed; border:none; border-radius: 40px 10px;  text-align:center; margin-top: -90vh; font-size: 24px; margin-left: 43vw; width: 15%; height: 4%; z-index: 2; color:blue; background-color: white;">
    <p>
        {{ 'PLEASE_CHECK' | translate }}: {{nextPointToSelectForAlignment}}
    </p>
</div>

<mat-card class="right shadow p-3 mb-5 rounded scrollable">
    <div class="col-12 justify-content-center">

        <div class="box">
            <label>{{ 'FILE' | translate }}</label>
            <select class="form-control category-select" [(ngModel)]="selectedFile" #fileSelect
                (change)='fileSelect.blur(); onFileSelectedChange(fileSelect.value)'>

                <optgroup *ngIf="files.length > 0" label="{{ 'FILES' | translate }}">
                    <option *ngFor="let file of files" [value]="file.name" [selected]="file.name == selectedFile">
                        {{ file.name }}
                    </option>
                </optgroup>

            </select>
        </div>

        <mat-card class="col-12 shadow p-2 mb-3 rounded" style="margin-top: 12px;">
            <label>{{ 'SCALING' | translate }}</label>
            <div class="d-flex justify-content-between">
                <button mat-button color="primary" (click)="scaleModel(10)">x10</button>
                <button mat-button color="primary" (click)="scaleModel(100)">x100</button>
                <button mat-button color="primary" (click)="scaleModel(1000)">x1000</button>
                <button mat-button color="warn" (click)="scaleModel(1)">{{ 'RESET' | translate }}</button>
            </div>
        </mat-card>

        <div class="col-12 shadow p-2 mb-3 rounded" style="margin-top: 12px;">
            <label>{{ 'CLIPPING_VALUES' | translate }}</label>
            <label class="btn btn-info col-12">
                <div class="custom-control custom-checkbox mr-sm-2" style="margin-top: 12px;">
                    <input type="checkbox" class="custom-control-input" id="checkbox0" (click)="toggleClipping()"
                        [(checked)]="renderer.localClippingEnabled">
                    <label class="custom-control-label" for="checkbox0">{{ 'CLIPPING' | translate }}</label>
                </div>
            </label>
            <ngx-slider *ngFor="let slider of sliderOptions" [(value)]="slider.value" [options]="slider.options"
                (valueChange)="changeClippingValue(slider.value, slider.type)"></ngx-slider>
        </div>


        <!-- <ngx-slider *ngFor="let slider of meshDeform" [(value)]="slider.value" [options]="slider.options"
                (valueChange)="deformMesh(slider.value, slider.type)"></ngx-slider> -->

        <!-- <div class="col-12 shadow p-2 mb-3 rounded" *ngIf="fileLoaded && !fileLoaded.paid" style="margin-top: 12px;">
            <label>Post-processing</label>

            <div>
                <label class="btn btn-info col-12">
                    <div class="custom-control custom-checkbox mr-sm-2">
                        <input type="checkbox" class="custom-control-input" id="checkbox1"
                            [(checked)]="postProcessing.mergeCloseVertices"
                            (change)="postProcessing.mergeCloseVertices = !postProcessing.mergeCloseVertices">
                        <label class="custom-control-label" for="checkbox1">Merge close vertices</label>
                    </div>
                </label>
            </div>

            <div>
                <label class="btn btn-info col-12">
                    <div class="custom-control custom-checkbox mr-sm-2">
                        <input type="checkbox" class="custom-control-input" id="checkbox2"
                            [(checked)]="postProcessing.smooth"
                            (change)="postProcessing.smooth = !postProcessing.smooth">
                        <label class="custom-control-label" for="checkbox2">Smooth</label>
                    </div>
                </label>

                <ngx-slider *ngIf="postProcessing.smooth" [(value)]="postProcessing.smoothSteps"
                    [options]="smoothStepsOptions"></ngx-slider>
            </div>

            <div>
                <label class="btn btn-info col-12">
                    <div class="custom-control custom-checkbox mr-sm-2">
                        <input type="checkbox" class="custom-control-input" id="checkbox3"
                            [(checked)]="postProcessing.fillHoles"
                            (change)="postProcessing.fillHoles = !postProcessing.fillHoles">
                        <label class="custom-control-label" for="checkbox3">Fill holes</label>
                    </div>
                </label>
                <ngx-slider *ngIf="postProcessing.fillHoles" [(value)]="postProcessing.reconstructionDepth"
                    [options]="reconstructionDepthOptions"></ngx-slider>
            </div>


            <label class="btn btn-info col-12">
                <div class="custom-control custom-checkbox mr-sm-2">
                    <input type="checkbox" class="custom-control-input" id="checkbox4"
                        [(checked)]="postProcessing.removeSmallParts"
                        (change)="postProcessing.removeSmallParts = !postProcessing.removeSmallParts">
                    <label class="custom-control-label" for="checkbox4">Remove small parts</label>
                </div>
            </label>


            <button type="button" mat-raised-button color="primary" (click)="processFile(fileLoaded)"
                style="margin-top: 12px; margin-bottom: 10px;">Start
                process</button>

        </div> -->

        <div *ngIf="fileLoaded && fileLoaded.autoAligned" class="col-12 shadow p-2 mb-3 rounded">

            <div>
                <label>{{ 'AUTO_ALIGNMENT' | translate }}</label>
                <br>
                <span class="badge badge-primary"
                    [className]="fileLoaded.autoAlignStatus == 'success' ? 'badge badge-pill badge-success' : 'badge badge-pill badge-danger'">{{fileLoaded.autoAlignStatus}}</span>
            </div>


            <div *ngIf="fileLoaded.refundStatus">
                <label>{{ 'REFUND' | translate }}</label>
                <br>
                <span class="badge badge-pill badge-primary">{{fileLoaded.refundStatus}}</span>
            </div>

            <div *ngIf="!fileLoaded.refundStatus && fileLoaded.autoAlignStatus == 'success'">
                <hr>
                {{ 'REFUND_REQUEST' | translate }}

                <button type="button" mat-raised-button color="primary" (click)="refund(fileLoaded.path)">{{ 'REFUND' |
                    translate }}</button>
            </div>


        </div>

        <div *ngIf="fileLoaded && fileLoaded.paid && aligningPoints.length == 3" class="gap-3">
            <h2>{{'colors' | translate}}</h2>

            <div class="flex flex-column gap-3 mb-5">
                <div class="flex align-items-center">
                    <p-radioButton name="{{ 'RED_YELLOW_BLUE' | translate }}" value="red_yellow_blue"
                        [(ngModel)]="savedColor" (change)="saveColor('blue')" inputId="ingredient1" />
                    <label for="ingredient1" class="ml-2">
                        {{ 'RED_YELLOW_BLUE' | translate }}
                    </label>
                </div>

                <div class="flex align-items-center">
                    <p-radioButton name="{{ 'BLUE' | translate }}" value="blue" [(ngModel)]="savedColor"
                        (change)="saveColor('red_yellow_blue')" inputId="ingredient2" />
                    <label for="ingredient2" class="ml-2">
                        {{ 'BLUE' | translate }}
                    </label>
                </div>
            </div>

            <p-button label="{{ 'PEDIGRAPHY' | translate }}" (click)="SaveCapture()" />
        </div>
    </div>
</mat-card>

<!-- Product Selector Modal -->
<app-product-selector #productSelector (productSelected)="onProductSelected($event)"></app-product-selector>